module.exports = __webpack_public_path__ + "assets/img/2021_1.31a6ae8d.png";